import { motion } from "framer-motion";

const team = [
  {
    name: "CA Adityakumar H V",
    role: "Founding Partner · FCA",
    intro:
      "With 11+ years of post-qualification experience, Adityakumar specialises in delivering robust financial governance, strategic advisory, and cross-border taxation solutions to drive business growth.",
    expertise: [
      {
        h: "Audit & Assurance",
        p: "End-to-end statutory and internal audits for listed and unlisted corporate entities.",
      },
      {
        h: "Taxation & Advisory",
        p: "Complex tax planning, compliance, and structuring for domestic and international jurisdictions.",
      },
      {
        h: "Virtual CFO Services",
        p: "Scalable, high-level financial leadership, cash flow management and strategic scaling for global clients.",
      },
    ],
    sectors:
      "Deep domain expertise across Hospitals & Healthcare, Education, Software, Real Estate and Investment Funds — in India and overseas.",
    initials: "AH",
    photo:
      "https://customer-assets.emergentagent.com/job_chartered-anand/artifacts/bv2bitln_AKHV%20PASSPORT%20SIZE%20PHOTO.jpg",
  },
  {
    name: "CA Anand M Hegde",
    role: "Founding Partner · ACA",
    intro:
      "A qualified Chartered Accountant (2016) with robust experience spanning Ind AS implementation, statutory audit and internal audit across diverse sectors.",
    paragraphs: [
      "Anand began his career with a well-known Bengaluru-based CA firm, where he was actively involved in audit and assurance engagements and the practical rollout of Ind AS for corporate clients.",
      "He subsequently gained over five years of corporate finance and compliance experience with a listed NBFC and a manufacturing company — working closely on financial reporting, regulatory compliance and strengthening internal control systems. This blend of firm-side and industry-side exposure allows him to understand both the auditor's perspective and the management's operational realities.",
      "Since 2024, Anand has been in independent practice, focusing on audit and assurance, Ind AS and financial reporting advisory, and corporate and tax compliances — bringing a detail-oriented, process-driven approach to every engagement.",
    ],
    expertise: [],
    sectors: "",
    initials: "AM",
    photo:
      "https://customer-assets.emergentagent.com/job_chartered-anand/artifacts/bmhcj3xg_WhatsApp%20Image%202026-06-12%20at%2010.07.05%20PM-removebg-preview.jpg",
  },
];

export default function Team() {
  return (
    <section id="team" data-testid="team-section" className="py-24 md:py-32 bg-[#EBE7DF]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-8">
            <div className="overline mb-5">/ The Partners</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-tight text-[#1B3B2B]">
              Two chartered accountants. One ledger of accountability.
            </h2>
          </div>
          <p className="lg:col-span-4 text-[#4A5D53] text-base leading-relaxed">
            Each partner signs the work that leaves the firm — drafts, opinions and filings.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {team.map((p, i) => (
            <motion.article
              key={p.name}
              data-testid={`team-card-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="card-flat p-7 md:p-9 flex flex-col"
            >
              <div className="flex gap-6 items-start">
                <div className="w-32 h-32 sm:w-40 sm:h-40 bg-[#1B3B2B] text-[#D4AF37] grid place-items-center overflow-hidden shrink-0">
                  {p.photo ? (
                    <img
                      src={p.photo}
                      alt={p.name}
                      className="w-full h-full object-cover object-top"
                      data-testid={`team-photo-${i}`}
                    />
                  ) : (
                    <span className="font-serif-display text-5xl">{p.initials}</span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="overline text-[10px] mb-2">{p.role}</div>
                  <h3 className="font-serif-display text-2xl text-[#1B3B2B] leading-snug">
                    {p.name}
                  </h3>
                  <p className="mt-3 text-sm text-[#4A5D53] leading-relaxed">{p.intro}</p>
                </div>
              </div>

              {p.paragraphs && p.paragraphs.length > 0 && (
                <div className="mt-6 pt-5 border-t border-[#D1CEC5] space-y-3">
                  {p.paragraphs.map((para, idx) => (
                    <p key={idx} className="text-sm text-[#4A5D53] leading-relaxed">
                      {para}
                    </p>
                  ))}
                </div>
              )}

              {p.expertise && p.expertise.length > 0 && (
                <div className="mt-7 pt-6 border-t border-[#D1CEC5]">
                  <div className="overline text-[10px] mb-4">Core Expertise</div>
                  <ul className="space-y-4">
                    {p.expertise.map((e) => (
                      <li key={e.h} className="text-sm">
                        <div className="font-serif-display text-base text-[#1B3B2B]">{e.h}</div>
                        <p className="text-[#4A5D53] mt-0.5 leading-relaxed">{e.p}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {p.sectors && (
                <div className="mt-6 pt-5 border-t border-[#D1CEC5]">
                  <div className="overline text-[10px] mb-2">Sector Highlights</div>
                  <p className="text-sm text-[#4A5D53] leading-relaxed">{p.sectors}</p>
                </div>
              )}
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
